import gql from 'graphql-tag'

export default gql`mutation scheduleOperation($operation: String!, $parameters: [NameIdValueInput]) {
	scheduleOperation(operation: $operation, parameters: $parameters )
    {
      operation
      pods {
        facility_ids
        group_id
        id
        name
        user_ids
        providers {
          user_id
          name
          provider_id
        }
        date_created
      }
      shifts {
        catchall
        end
        id
        name
        outpatient
        personal
        personal_coveree
        personal_coverer
        rounding   
        rotation
        start
        type
        filter
        rounding_facilities
        weekdays
        assign_new_patient
        assign_temporary
        assignments {
          day
          month
          pod_id
          skip_rotation
          template_id
          user_id
          year
          shift_id
          shift_type
          shift_name
          added_by
          date_added
        }
        rules
        start_year
        start_month
        start_day
        start_hours
        start_minutes
        start_seconds
        end_year
        end_month
        end_day
        end_hours
        end_minutes
        end_seconds
    }
    data {
        name
        id
        value
    }      
    users {
        id
        first_name
        last_name
        group {
          id
          name
        }
        roles
        user_index
        settings {
          preferences {
            name
            value
            id
          }
        }
        rounding_facilities {
          name
          id
        }
		  }
      filters {
        id
        name
        default_options {
          id
          type
          name
          operator
          value_json  
        }
        rules
        message_fields {
          id
          type
          name
          operator
          value_json          
        }
        deleted
        priority
        user_id
        user_name
        user_type
        group
        date_created
        created_by
        created_by_first_name
        created_by_last_name
        date_deleted
        deleted_by
        last_edit_date
        last_edit_by        
      }   

      facilities {
        id
        name
        shortcode
        units {
          established_patients_only
          unit_id
          name
          number
          shortcode
          new_patients
          default_patient_status
        }
      }

  }
}`
